/**
 * Audio Transcription
 *
 * Sends an audio blob to the AI gateway's `stt` role for speech-to-text.
 * Shared by both the React ChatPanel (via useVoiceInput) and the
 * Babylon.js XRAssistantPanel.
 */

import { callCapability } from './gateway';
import type { VoiceTiming } from './voice-timing';

/**
 * Transcribe an audio blob: one normalized POST, and the server picks the model
 * (currently Azure gpt-4o-mini-transcribe, measured at 1.00s against 1.49s for
 * Gemini on the same clip with an identical transcript).
 *
 * Returns the transcript, or null if the audio is empty/inaudible.
 * Throws on API errors.
 */
export async function transcribeAudio(
    audioBlob: Blob,
    mimeType: string,
    timing?: VoiceTiming,
): Promise<string | null> {
    // The clip goes as a file part, typed as recorded.
    const audio = new Blob([audioBlob], { type: mimeType });
    const result = await callCapability<{ text: string | null }>('speech/transcribe', {}, undefined, { audio: [audio] });
    timing?.mark('stt_body_parsed');
    return result.text;
}
